/**
 * The password policy, for live feedback while typing.
 *
 * Mirrors `PASSWORD_PATTERN` in `backend/src/common/validation/patterns.ts`.
 * Presentation only — the API enforces the rule and is the one that counts.
 */
export const PASSWORD_RULES: ReadonlyArray<{ label: string; test: (value: string) => boolean }> = [
  { label: 'At least 10 characters', test: (value) => value.length >= 10 },
  { label: 'An uppercase letter', test: (value) => /[A-Z]/.test(value) },
  { label: 'A lowercase letter', test: (value) => /[a-z]/.test(value) },
  { label: 'A number', test: (value) => /\d/.test(value) },
];

export function meetsPasswordPolicy(value: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(value));
}
